import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeToggleComponent } from '../../components/theme-toggle/theme-toggle.component';

/**
 * Shell de las pantallas sin sesion (login).
 *
 * Solo centra el contenido sobre el lienzo de auroras que ya pinta `<body>`:
 * no dibuja cristal propio para que la tarjeta de la pagina sea la unica
 * superficie de primer nivel.
 */
@Component({
  selector: 'app-session-layout',
  imports: [RouterOutlet, ThemeToggleComponent],
  templateUrl: './session-layout.component.html',
  styleUrl: './session-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionLayoutComponent {}
